import { NavBarBtnModel } from 'common/src/models';
import { ProductTypes } from 'common/src/modules/products/product-types';
import {
  ControlTypeEnum,
  InputDropdownTypeEnum,
  PositionInfoListModel,
  PositionItemTypeEnum
} from 'common/src/modules/position-card/position-card-models.model';
import { SalesOrderListTabsEnum } from '../../../../../sales-order/enums';
import { PriceOptionEnum } from '../../../../../shared/enums';

export const PositionsButtons: NavBarBtnModel[] = [
  {
    classes: 'btn-white red',
    text: 'BUTTON.REMOVE',
    multipleText: 'BUTTON.REMOVE',
    badgeClass: 'rnpl-badge--red',
    iconName: 'minus-circle',
    actionName: 'onDeletePositionsClick',
  }
];

export function generatePositionsCardsInfo(
  productType: ProductTypes,
  documentStatus: string,
  priceOption: PriceOptionEnum
): PositionInfoListModel[] {

  let positionInfoList: PositionInfoListModel[] = [
    {
      label: 'FORM.DESCRIPTION',
      prop: 'productDescription',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXT_EDITOR,
      // itemClass: 'col-12',
      // isOptional: true,
      hideWithProductType: [ProductTypes.SERVICES],
    },
    {
      label: 'FORM.DESCRIPTION',
      prop: 'providedServices',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXT_EDITOR,
      // itemClass: 'col-12',
      // isOptional: true,
      hideWithProductType: [ProductTypes.GOODS, ProductTypes.DIGITAL],
    },
    {
      label: 'COLUMN.QUANTITY',
      hintId: 'quantityColumn',
      prop: 'quantity',
      unitType: 'unitType',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.NUMBER,
    },
    {
      label: 'COLUMN.UNIT_PRICE_NET',
      prop: 'netUnitPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      currencyIsOriginal: true,
      showCondition: priceOption === PriceOptionEnum.NET
    },
    {
      label: 'COLUMN.UNIT_PRICE_GROSS',
      prop: 'grossUnitPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      currencyIsOriginal: true,
      showCondition: priceOption === PriceOptionEnum.GROSS
    },
    {
      label: 'COLUMN.AMOUNT_NET',
      prop: 'netTotalPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      currencyIsOriginal: true,
      showCondition: priceOption === PriceOptionEnum.NET
    },
    {
      label: 'COLUMN.AMOUNT_GROSS',
      prop: 'grossTotalPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      currencyIsOriginal: true,
      showCondition: priceOption === PriceOptionEnum.GROSS
    },
    {
      label: 'COLUMN.MARGIN',
      prop: 'marginData',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.PROFIT,
      currencyConversion: true,
      hideWithProductType: [ProductTypes.DIGITAL],
      showWithDocumentStatus: [
        SalesOrderListTabsEnum.DRAFT,
        SalesOrderListTabsEnum.OPEN,
        SalesOrderListTabsEnum.COMPLETED,
      ],
    },
  ];

  positionInfoList = positionInfoList
    .filter((item) => {
      if (item.hideWithProductType) {
        return !item.hideWithProductType.includes(productType);
      }
      return true;
    })
    .filter((item) => {
      if (item.showWithDocumentStatus) {
        return item.showWithDocumentStatus.includes(documentStatus);
      }
      return true;
    })
    .filter((item) => !item.hasOwnProperty('showCondition') || item.showCondition);

  return positionInfoList;
}
